import React from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import ScrollToTop from "../../components/ScrollTop";
import Logo from "../../assets/images/logos/logo2.png";

const LegalDisclaimer = () => {
  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        topbarEnable="enable"
      />

      <div className="container" style={{ paddingBottom: "120px" }}>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-sm border-0">
              <div className="card-body p-4 p-md-5">
                <h4 className="text-center mb-4">
                  Terms of Use & Legal Disclaimer
                </h4>

                {/* Terms of Use Section */}
                <section className="mb-5">
                  <h6 className="mb-3">Terms of Use</h6>
                  <p>
                    By accessing this website, you acknowledge your assent to
                    these terms without limitation or qualification. These terms
                    may be revised at any time by updating this page. You are
                    bound by such revisions and should periodically review these
                    terms.
                  </p>
                </section>

                {/* Brand Ownership */}
                <section className="mb-5">
                  <h6 className="mb-3">1. Brand Ownership</h6>
                  <p>
                    "IAS Jnani" is an educational initiative operated under{" "}
                    <strong>Jnani Educational Private Limited</strong>. This
                    brand name is used for educational purposes only and is not
                    a separate legal entity.
                  </p>
                </section>

                {/* Trademark Disclaimer */}
                <section className="mb-5">
                  <h6 className="mb-3">2. Trademark Disclaimer</h6>
                  <ul className="list-unstyled">
                    <li className="mb-2">
                      "IAS" is a registered trademark of the{" "}
                      <strong>Union Public Service Commission (UPSC)</strong>.
                    </li>
                    <li className="mb-2">
                      "IAS Jnani" is an independent coaching institute and{" "}
                      <strong>not affiliated with or endorsed by UPSC</strong>{" "}
                      or the Indian government.
                    </li>
                    <li>
                      We use "IAS" <strong>descriptively</strong> to refer to
                      training for the civil services examination.
                    </li>
                  </ul>
                </section>

                {/* Disclaimers */}
                <section className="mb-5">
                  <h6 className="mb-3">3. Disclaimers</h6>
                  <p>
                    The materials on this website are provided "as is" without
                    warranties of any kind. Jnani Educational Private Limited
                    disclaims all warranties including merchantability and
                    fitness for purpose.
                  </p>
                  <p className="mt-3">
                    We do not warrant that the website will be error-free or
                    virus-free. The inclusion of any third-party links does not
                    imply endorsement.
                  </p>
                </section>

                {/* Limitation of Liability */}
                <section className="mb-5">
                  <h6 className="mb-3">4. Limitation of Liability</h6>
                  <p>
                    Under no circumstances shall Jnani Educational Private
                    Limited be liable for any direct, indirect, or consequential
                    damages resulting from website use. Our total liability
                    shall not exceed fees paid by you, if any.
                  </p>
                </section>

                {/* Restrictions */}
                <section className="mb-5">
                  <h6 className="mb-3">5. Restrictions on Use</h6>
                  <p>
                    All content is copyrighted by Jnani Educational Private
                    Limited. You may download materials for personal use only,
                    retaining all copyright notices. Commercial use requires
                    written permission.
                  </p>
                </section>

                {/* Jurisdiction */}
                <section className="mb-5">
                  <h6 className="mb-3">6. Jurisdiction</h6>
                  <p>
                    All disputes shall be subject to the exclusive jurisdiction
                    of New Delhi courts. This website is not an offer to sell
                    products where prohibited by law.
                  </p>
                </section>

                {/* Intellectual Property */}
                <section className="mb-5">
                  <h6 className="mb-3">7. Intellectual Property</h6>
                  <p>
                    All trademarks, logos, and content are proprietary to Jnani
                    Educational Private Limited. Unauthorized use may violate
                    copyright, trademark, and other laws.
                  </p>
                </section>

                {/* Privacy Policy */}
                <section className="mb-5">
                  <h6 className="mb-3">8. Privacy Policy</h6>
                  <p>We collect personal data for:</p>
                  <ul style={{ listStyleType: "disc" }}>
                    <li className="mb-2">Course updates and support</li>
                    <li className="mb-2">
                      Payment processing via secure gateways
                    </li>
                    <li>Service improvement</li>
                  </ul>
                  <p className="mt-3">
                    <strong>We do not sell/share data</strong> with third
                    parties.
                  </p>
                </section>

                {/* Refund Policy */}
                <section>
                  <h6 className="mb-3">9. Refund Policy</h6>
                  <ul>
                    <li className="mb-2">
                      Fees are non-refundable except in exceptional
                      circumstances (Eg. If batch is cancelled by organization).
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ScrollToTop />

      <FooterTwo />
    </>
  );
};

export default LegalDisclaimer;
